import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'Application' })(theme => ({
	root: {
		background: theme.palette.background.default,
		color: theme.palette.text.primary,
		fontWeight: theme.typography.fontWeightRegular,
		'& ::selection': {
			background: theme.palette.primary.main,
			color: '#ffffff'
		},
		'&::selection': {
			background: theme.palette.primary.main,
			color: '#ffffff'
		}
	}
}));

export type ApplicationBaselineProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * Wraps application with css baseline. Sets background, color, font-weight, selection color and other properties.
 * @param props Properties.
 * @returns React element.
 */
export const ApplicationBaseline: React.FC<ApplicationBaselineProps> = (props) => {
	const { className, ...other } = props;
	const { classes, cx } = useStyles();
	return <div {...other} className={cx(classes.root, className)} />;
};
